export default __webpack_public_path__ + "static/media/SleepNumberLogo.fdc73aa5.png";